import React from "react";

import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import { Button } from "@/src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/src/components/ui/dropdown-menu";

import { SmartlistType } from "../../api/MediaAPI.types";
import { SMARTLIST_TYPE_ICONS } from "../common/smartlist/smartlistTypeIcons";
import { PROJECTS_ROUTE } from "../routes/routes";

import type { JSX } from "react";

const StandardIcon = SMARTLIST_TYPE_ICONS[SmartlistType.STANDARD];
const AutoIcon = SMARTLIST_TYPE_ICONS[SmartlistType.AUTO];

function CreateSmartlistButton(): JSX.Element {
  const { t } = useTranslation("editor-smartlist");
  const history = useHistory();
  const { projectSlug } = useParams<{ projectSlug: string }>();

  const handleCreate = (segment: string): void => {
    history.push(`${PROJECTS_ROUTE}/${projectSlug}/${segment}/new`);
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button size="lg" type="button">
          <Plus />
          {t("createSmartlist")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onSelect={() => handleCreate("smartlist-standard")}>
          <StandardIcon />
          {t("standardSmartlist")}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => handleCreate("smartlist-auto")}>
          <AutoIcon />
          {t("autoSmartlist")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default CreateSmartlistButton;
